// extracted by mini-css-extract-plugin
export var container = "_di-0";
export var icon = "_di-1";
export var text = "_di-2";